module.exports = __webpack_public_path__ + "52498f5dda15056935cd0a17ff5b2481.pdf";